var navHandler = {
	$adjustTopSections: [],
	$transparentHeader: [],

	scrollTimer: null,

	toggleNav: function() {

	},

	init: function() {
		var self = this;
		this.$adjustTopSections = $('section:first-of-type').not('.no-adjust-top');
		this.$transparentHeader = $('header.transparent');
    // adjust top margin
    if (this.$adjustTopSections.length > 0) {
      this.$adjustTopSections.css('margin-top', $header.outerHeight());
    }
		$window.on("scroll", function() {
			clearTimeout(self.scrollTimer);
			self.scrollTimer = setTimeout(function() {
				var scrollLimit = 250;
				if ($window.scrollTop() > scrollLimit) {
					self.$transparentHeader.removeClass('on-top');
				} else {
					self.$transparentHeader.addClass('on-top');
				}
			}, 10);
		})
	}
}